<template>
  <div class="lz-home-toolbar" v-if="admin">
    <b-button
      size="sm"
      v-if="value && showManage"
      class="lz-pill-btn"
      @click="$emit('manage')">
      <b-icon-list-ul></b-icon-list-ul>Manage Sections
    </b-button>
    <b-button size="sm" v-if="value" class="lz-pill-btn" @click="$emit('add')">
      <b-icon-plus></b-icon-plus>{{ addLabel }}
    </b-button>
    <b-button
      size="sm"
      class="lz-edit-toggle"
      :class="{ active: value }"
      @click="$emit('input', !value)">
      <b-icon-pencil scale="0.9"></b-icon-pencil>{{ value ? 'Done' : 'Edit' }}
    </b-button>
  </div>
</template>

<script>
export default {
  // Admin toolbar shared by the home resource modules. `value` is the edit-mode
  // flag, so parents can bind it with v-model.
  name: 'HomeResourceToolbar',
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    admin: {
      type: Boolean,
      required: false,
      default: false
    },
    showManage: {
      type: Boolean,
      required: false,
      default: true
    },
    addLabel: {
      type: String,
      required: false,
      default: 'Add Resource'
    }
  }
}
</script>
